import './SkeletonLoader.scss'

const SkeletonLoader = ({ children, loading = true, style = {}, cx = '' }) => {
    if (loading) {
        return <div className={`skeleton-loader ${cx}`} style={{ ...style }} />
    }

    return children
}

export default SkeletonLoader
